import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from 'vue'
import { VAutocomplete } from 'vuetify/components'
type GroupObject = { id: number; name: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'OperationalGroupSelect',
  props: {
  modelValue: { type: Object as PropType<GroupObject | null>, default: null },
  disabled: { type: Boolean, default: false },
  items: { type: Array as PropType<GroupObject[]>, default: () => [] },
  error: { type: Boolean, default: false },
  errorMessages: { type: [String, Array] as PropType<string | string[]>, default: '' },
  /**
   * Altura do campo. O default 'comfortable' é o histórico das telas de escala; use
   * 'default' para alinhar com os `GenericInput` de um formulário, que têm 56px.
   */
  density: {
    type: String as PropType<'default' | 'comfortable' | 'compact'>,
    default: 'comfortable'
  }
},
  emits: ["update:modelValue"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VAutocomplete), {
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    items: __props.items,
    "item-title": "name",
    "return-object": true,
    label: "Grupo Operacional",
    variant: "outlined",
    color: "primary20",
    density: __props.density,
    "no-data-text": "Nenhum grupo encontrado",
    clearable: "",
    disabled: __props.disabled,
    error: __props.error,
    "error-messages": __props.errorMessages,
    "hide-details": "auto"
  }, null, 8, ["model-value", "items", "density", "disabled", "error", "error-messages"]))
}
}

})